import React, { useState, useEffect } from 'react';

function CookieConsentComponent() {

    //Set state
    const [cookieConsentShown, setCookieConsentShown] = useState(false);

    useEffect(() => {
        // Check if body tag contains w__equipe, set websiteClass to either equipe or spero
        const websiteClass = document.body.classList.contains('w__equipe') ? 'equipe' : 'spero';
        // Create a cookie name for Equipe / Spero
        const cookieName = `client_cookie_${websiteClass}`;

        // Check if function has run
        if (cookieConsentShown || document.cookie.includes(`${cookieName}=approved`)) {
            return;
        }

        try {
            // Create div and classname
            const cookieContainer = document.createElement("div");
            cookieContainer.className = "cookie-container";

            // Create message 
            const messageText = document.createElement("span");
            messageText.innerHTML = `${websiteClass.charAt(0).toUpperCase()}${websiteClass.slice(1)} använder cookies för att kunna ge en optimerad användarupplevelse. Genom att fortsätta på sidan accepterar du cookies.`;
            messageText.id = "cookie_message";

            // Create accept button
            const acceptButton = document.createElement("button");
            acceptButton.innerHTML = "Jag accepterar";
            acceptButton.classList.add(`${websiteClass}-button`);
            acceptButton.classList.add("button");
            acceptButton.style.cursor = 'pointer';
            acceptButton.addEventListener("click", setCookie);

            // Append to container
            cookieContainer.appendChild(messageText);
            cookieContainer.appendChild(acceptButton);

            // Append container to document
            document.body.appendChild(cookieContainer);

            // Create session cookie
            function setCookie() {
                document.cookie = `${cookieName}=approved;path=/`;
                cookieContainer.style.display = 'none';
                setCookieConsentShown(true);
            }

            // Set flag to true
            setCookieConsentShown(true);

        // Catch errors
        } catch (err) {
            console.error(err);
        }
    }, [cookieConsentShown]);

    // Returnera null if component dont run
    if (!cookieConsentShown) {
        return null;
    }

    return null;
}

export default CookieConsentComponent;
